import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de-CH';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { CardioExplorerPreset } from './theme/cardio-explorer-preset';
import { PrimeNgModule } from './shared/modules';
import { AuthInterceptor } from './core/interceptors';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { AuthService } from './core/services/auth.service';
import { TranslationService } from './shared/services/translation.service';

// Register the Swiss locale
registerLocaleData(localeDe);

// Factory ensures TranslationService is created early in the app lifecycle
export const initializeTranslations = () => () => Promise.resolve();

const COMPONENTS = [AppComponent];
const BASE_MODULES = [BrowserModule, AppRoutingModule, CoreModule, HttpClientModule, BrowserAnimationsModule];
const MODULES = [SharedModule, PrimeNgModule];
const SERVICES = [MessageService, DialogService];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'en',
    }),
    ...BASE_MODULES,
    ...MODULES,
  ],
  providers: [
    ...SERVICES,
    providePrimeNG({
      theme: {
        preset: CardioExplorerPreset,
        options: { darkModeSelector: false },
      },
    }),
    provideTranslateHttpLoader(),
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: '/assets/i18n/', suffix: '.json' } },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'de-CH' },
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => authService.initAuth(),
      deps: [AuthService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [TranslationService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
